import React, { useState } from "react";
import {
  FormControl,
  MenuItem,
  InputLabel,
  Box,
  Select,
  useTheme,
} from "@mui/material";
import { ResponsivePie } from "@nivo/pie";
import { PageContainer } from "components/shared";
import {
  useGetCategoryAnalyticsQuery,
  useGetDashboardQuery,
} from "state/api";

const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

const Overview = () => {
  const theme = useTheme();
  const [view, setView] = useState("category");
  const { data: catData } = useGetCategoryAnalyticsQuery();
  const { data: dashData } = useGetDashboardQuery();

  const categoryData = (catData?.data ?? []).map((c) => ({
    id: c.category,
    label: c.category,
    value: c.revenue || 0,
  }));

  const ordersByStatus = dashData?.data?.ordersByStatus ?? {};
  const statusData = Object.entries(ordersByStatus).map(([key, value]) => ({
    id: cap(key),
    label: cap(key),
    value: value || 0,
  }));

  const pieData = view === "status" ? statusData : categoryData;

  const chartColors = [
    theme.palette.primary.main,
    theme.palette.secondary.main,
    theme.palette.primary[300],
    theme.palette.secondary[300],
    theme.palette.warning.main,
    theme.palette.info.main,
    theme.palette.error.main,
    theme.palette.success.main,
  ];

  return (
    <PageContainer
      title="Overview"
      subtitle="Overview of category revenue and order status"
    >
      <Box height="75vh">
        <FormControl sx={{ mt: "1rem" }}>
          <InputLabel>View</InputLabel>
          <Select
            value={view}
            label="View"
            onChange={(e) => setView(e.target.value)}
          >
            <MenuItem value="category">Category Revenue</MenuItem>
            <MenuItem value="status">Order Status</MenuItem>
          </Select>
        </FormControl>
        <Box height="calc(75vh - 80px)">
          <ResponsivePie
            data={pieData}
            theme={{
              legends: {
                text: {
                  fill: theme.palette.secondary[200],
                },
              },
              tooltip: {
                container: {
                  color: theme.palette.primary.main,
                },
              },
            }}
            colors={chartColors}
            margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
            sortByValue={true}
            innerRadius={0.45}
            activeOuterRadiusOffset={8}
            borderWidth={1}
            borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
            arcLinkLabelsTextColor={theme.palette.secondary[200]}
            arcLinkLabelsThickness={2}
            arcLinkLabelsColor={{ from: "color" }}
            arcLabelsSkipAngle={10}
            valueFormat={(v) =>
              view === "status"
                ? Number(v).toLocaleString("en-IN")
                : `₹${Number(v).toLocaleString("en-IN")}`
            }
            legends={[
              {
                anchor: "bottom",
                direction: "row",
                justify: false,
                translateX: 0,
                translateY: 56,
                itemsSpacing: 0,
                itemWidth: 100,
                itemHeight: 18,
                itemTextColor: theme.palette.text.secondary,
                itemDirection: "left-to-right",
                itemOpacity: 1,
                symbolSize: 18,
                symbolShape: "circle",
                effects: [
                  {
                    on: "hover",
                    style: {
                      itemTextColor: theme.palette.primary[500],
                    },
                  },
                ],
              },
            ]}
          />
        </Box>
      </Box>
    </PageContainer>
  );
};

export default Overview;
